export const SERVICE_DATA_LOADED = 'SERVICE_DATA_LOADED';
